
const ImageSet = (mobileImage, tabletImage, desktopImage) => {
  return {
    mobileImage: mobileImage || '',
    tabletImage: tabletImage || '',
    desktopImage: desktopImage || ''
  };
};

export default ImageSet;


// WEBPACK FOOTER //
// ./src/utils/ImageSets.js